const AboutUs = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">O nas</h1>
      <p>
        <strong>Bazarc</strong> je slovenska spletna platforma za nakup in prodajo rabljenih izdelkov.
        Naš cilj je spodbujati krožno gospodarstvo in dati izdelkom drugo življenje.
      </p>
      <p>
        Verjamemo v enostavno, varno in prijetno spletno trgovanje — za vsakogar.
        Pridruži se tisočim uporabnikom in pomagaj soustvarjati bolj trajnostno prihodnost.
      </p>
    </div>
  );
};

export default AboutUs;